module.exports = __webpack_public_path__ + "media/shared/assets/fonts/Rubik/Rubik-Bold-c934eb22c2c69992b34c85801f5dbc38.ttf";